










import { Component, Vue } from 'vue-property-decorator';
import { MentoringIcon, MentoringHeader } from '../components';

@Component({
  components: {
    MentoringIcon,
    MentoringHeader,
  },
})
export default class MentoringDescription extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/description/MentoringDescription.vue